import { BEHIND_RED, BEHIND_YELLOW } from './schedule-status'

/**
 * Returns true if the schedule status is considered behind schedule
 * (ie 'behind-red' or 'behind-yellow')
 *
 * @param {ScheduleStatus} scheduleStatus
 *
 * @return {boolean}
 */
function isBehindSchedule (scheduleStatus) {
	return scheduleStatus === BEHIND_RED || scheduleStatus === BEHIND_YELLOW
}

export default isBehindSchedule

isBehindSchedule.__filename__ = 'initiatives/is-behind-schedule.js'
